var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceshipPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288.65 474.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ddd;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-2,.cls-3,.cls-6{stroke:#afafaf;}.cls-2,.cls-6{opacity:.8;}.cls-7{fill:#727272;}.cls-8{fill:url(#linear-gradient);}.cls-8,.cls-9{opacity:.3;}.cls-8,.cls-9,.cls-10{mix-blend-mode:multiply;}.cls-11{fill:#a0a0a0;}.cls-12{isolation:isolate;}.cls-13{fill:#232323;}.cls-14{fill:#e0e0e0;}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_65-2);}.cls-3{stroke-width:1.1px;}.cls-16{fill:#333;}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_75);}.cls-4{stroke-width:.66px;}.cls-4,.cls-5{stroke:#a0a0a0;}.cls-17{mix-blend-mode:darken;}.cls-17,.cls-10{opacity:.5;}.cls-17,.cls-18{fill:#5c7784;}.cls-19{fill:#969696;}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_101-2);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_65);}.cls-5{stroke-width:.93px;}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_101-3);}.cls-23{fill:#afafaf;}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_101);}.cls-25{fill:#e8e8e8;}.cls-26{fill:#9b9b9b;}.cls-27{fill:#ccc;}.cls-28{fill:#d7f1ff;mix-blend-mode:screen;opacity:.2;}.cls-6{stroke-width:1.49px;}.cls-29{fill:#5e5e5e;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65",
    cx: 40.35,
    cy: 42.85,
    fx: 40.35,
    fy: 42.85,
    r: 1.78,
    gradientTransform: "translate(2.01 -1.81) rotate(2.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fcee24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fcef2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fcf041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fcf25a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fdf47b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fdf7a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fefbd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_65-2",
    cx: 48.35,
    cy: 109.85,
    fx: 48.35,
    fy: 109.85,
    r: 1.78,
    gradientTransform: "translate(5.1 -2.1) rotate(2.63)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_65"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101",
    cx: 44.79,
    cy: 472.52,
    fx: 44.79,
    fy: 472.52,
    r: 3.77,
    gradientTransform: "translate(0 341.23) scale(1 .28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#faab39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#f99f36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f68b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f36f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f15a24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f05824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f05124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ef4524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ee3424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ed1f24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ed1c24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101-2",
    cx: 55.17,
    cy: 469.52,
    fx: 55.17,
    fy: 469.52,
    r: 4.16,
    gradientTransform: "translate(0 339.06) scale(1 .28)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_101"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101-3",
    cx: 34.18,
    cy: 469.52,
    fx: 34.18,
    fy: 469.52,
    r: 4.16,
    gradientTransform: "translate(0 339.06) scale(1 .28)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_101"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "spaceship_3",
    viewBox: "0 0 145.44 474.6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 40.35,
    cy: 42.85,
    rx: 2.09,
    ry: 1.39,
    transform: "translate(-1.93 1.9) rotate(-2.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 48.35,
    cy: 109.85,
    rx: 2.09,
    ry: 1.39,
    transform: "translate(-4.99 2.34) rotate(-2.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "70.66 140.78 0 140.78 0 25.78 47.84 25.78 47.9 26.33 47.92 26.46 64.66 113.13 70.66 140.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M63.04,378.69v79.23H24.98v-80.05c1.44-1.34,8.48-7.67,19.36-7.54,.4,0,.8,.02,1.19,.04,8.74,.47,14.68,5,16.88,6.93,.41,.35,.63,.85,.63,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M66,465.47c0,3.62-9.69,6.56-21.65,6.56s-21.65-2.94-21.65-6.56c0-2.36,4.1-4.42,10.26-5.58,3.31-.62,7.21-.98,11.4-.98s8.08,.36,11.4,.98c6.15,1.15,10.26,3.22,10.26,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66,454.32v11.15c0-2.35-4.1-4.42-10.26-5.58-3.31-.62-7.21-.98-11.39-.98s-8.09,.36-11.4,.98c-6.16,1.16-10.26,3.23-10.26,5.58v-11.15c0-1.06,.82-2.06,2.29-2.94,3.56-2.15,10.89-3.63,19.37-3.63,1.09,0,2.16,.02,3.21,.08,6.61,.29,12.24,1.49,15.48,3.17,1.88,.98,2.96,2.11,2.96,3.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.29,469.71c.19-.24,.3-.49,.3-.74,0-1.41-3.09-2.56-6.92-2.56s-6.92,1.15-6.92,2.56c0,.26,.1,.51,.3,.74-.52-.45-.81-.96-.81-1.51,0-1.84,3.33-3.33,7.43-3.33s7.43,1.49,7.43,3.33c0,.55-.29,1.06-.81,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M51.59,468.96l-.03,.22-.49,3.37h-12.81l-.49-3.37-.03-.22c0-1.41,3.09-2.56,6.92-2.56s6.92,1.15,6.92,2.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 44.67,
    cy: 472.55,
    rx: 6.4,
    ry: 2.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 44.67,
    cy: 472.55,
    rx: 5.89,
    ry: 1.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 44.79,
    cy: 472.52,
    rx: 5.2,
    ry: 1.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.38,466.42c.21-.26,.32-.53,.32-.81,0-.47-.31-.91-.86-1.3-.31-.22-.7-.42-1.14-.6-.24-.09-.49-.18-.77-.26-.38-.12-.8-.22-1.24-.31-.22-.05-.46-.09-.7-.12-.41-.07-.84-.11-1.29-.14l.3,4.48c-.41-.04-.83-.06-1.27-.07l.3-4.46c-.28-.01-.57-.02-.86-.02-.14,0-.3,0-.44,0-.22,0-.45,.01-.67,.03-.45,.02-.88,.06-1.29,.11-.24,.03-.47,.06-.69,.1-.45,.07-.87,.16-1.25,.27-.26,.07-.51,.14-.75,.22-.44,.15-.83,.32-1.17,.51-.8,.44-1.27,.97-1.27,1.55,0,.28,.11,.55,.32,.81-.56-.49-.88-1.05-.88-1.65,0-2,3.62-3.62,8.08-3.62,2.78,0,5.22,.62,6.68,1.59,.03,.01,.06,.03,.09,.06,.83,.56,1.32,1.25,1.32,1.98,0,.6-.31,1.15-.88,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M62.7,465.61l-.03,.24-.53,3.66h-13.94l-.53-3.66-.03-.24c0-1.54,3.37-2.79,7.53-2.79s7.53,1.25,7.53,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M62.14,469.52c0,1.23-3.12,2.23-6.97,2.23s-6.97-1-6.97-2.23c0-.42,.36-.81,.99-1.15,.17-.09,.37-.18,.58-.26,.39-.15,.85-.29,1.35-.41,.21-.05,.43-.09,.66-.13,.41-.07,.83-.13,1.29-.18,.22-.03,.46-.05,.7-.06,.41-.03,.83-.04,1.27-.05h.14c.19,0,.37,0,.56,.01,.44,0,.86,.03,1.27,.07,.24,.02,.47,.05,.69,.07,.46,.06,.89,.12,1.3,.22,.22,.04,.44,.09,.64,.15,.53,.14,.99,.31,1.37,.49,.21,.1,.39,.21,.54,.32,.38,.28,.59,.58,.59,.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 55.17,
    cy: 469.52,
    rx: 6.41,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 55.17,
    cy: 469.52,
    rx: 5.73,
    ry: 1.31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.38,466.42c.21-.26,.32-.53,.32-.81,0-1.54-3.37-2.79-7.53-2.79s-7.53,1.25-7.53,2.79c0,.28,.11,.55,.32,.81-.56-.49-.88-1.05-.88-1.64,0-2,3.62-3.62,8.09-3.62s8.09,1.62,8.09,3.62c0,.6-.32,1.15-.88,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M41.7,465.61l-.03,.24-.53,3.66h-13.94l-.53-3.66-.03-.24c0-1.54,3.37-2.79,7.53-2.79s7.53,1.25,7.53,2.79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 34.18,
    cy: 469.52,
    rx: 6.97,
    ry: 2.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 34.18,
    cy: 469.52,
    rx: 6.41,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 34.18,
    cy: 469.52,
    rx: 5.73,
    ry: 1.31
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 53.59,
    y1: 372.51,
    x2: 53.59,
    y2: 442.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.05,437.3v10.51c-4.73-3.94-11.48-6.39-18.97-6.39s-14.35,2.49-19.09,6.48v-10.43l1.59-1.3c4.61-3.26,10.75-5.25,17.49-5.25s12.88,1.99,17.49,5.25c.51,.36,1,.73,1.48,1.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "56.55 421.4 48.67 419.43 48.67 399.74 56.55 401.71 56.55 421.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "56.55 401.71 56.55 421.4 55.56 421.15 55.56 402.8 48.67 400.98 48.67 399.74 56.55 401.71"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M63.04,412.76v12.56l-4.71,8.9-2.07,3.91-2.67,3.05-1.14,1.31-3.19,3.64-11,11-12.64,.79-2.93,.18v-3.78c0-1.06,.82-2.06,2.29-2.94v-34.26h25.41l3.2-4.59,1.67-2.4,.3,.1,.99,.34,6.49,2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "48.74 269.52 38.42 269.52 33.38 269.52 1.03 269.52 1.03 140.32 70.43 140.32 70.77 141.59 78.42 192.57 78.83 194.1 84.92 228.8 85.33 230.34 85.83 269.52 48.74 269.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M145.34,318v48.69c0,.68-.23,1.34-.66,1.86l-8.61,10.56c-.46,.56-1.15,.89-1.88,.89h-9.47c-.76,0-1.38-.62-1.38-1.38v-12.3H1.34v-56.2l32.09-.39,5-.06,10.25-.12,36.66-.44h.11l50.65-.09c.79,0,1.55,.32,2.07,.91l7.17,8.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1.35,
    y: 268,
    width: 84.61,
    height: 81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "86.35 349 85.85 351.07 85.62 352.04 80.59 372.85 80.37 373.79 75.65 393.32 75.43 394.25 54.35 436 1.35 436 1.35 349 86.35 349"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "54.34 436 54.16 436.18 35.34 455 17.34 455 9.59 449.18 1.34 449 1.34 436 54.34 436"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "48.02 26 .08 26 .08 3 26.57 3 47.39 25.32 47.9 25.87 48.02 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "26.51 3 .08 3 .08 0 21.48 0 26.51 3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M42.68,32.5H.08V10.5H20.93c.3,0,.6,.03,.89,.1,.75,.15,1.41,.52,1.89,1.03l12.45,13.69,.61,.68,5.91,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M37.68,31.5H.08V12.5H18.5c.96,0,1.87,.37,2.45,.98l11,11.84,.62,.68,5.11,5.5Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "1.34 416 29.31 416 33.43 416 37.93 416 38.43 415.4 47.93 404 48.14 349 48.15 348.57 48.27 315.58 48.46 268.32 48.46 268 48.67 213.25 48.68 211.55 48.93 141.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.52,
    y1: 0.5,
    x2: 22.52,
    y2: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1.35,
    y: 302.72,
    width: 20.04,
    height: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27,
    y1: 3.5,
    x2: 24.35,
    y2: 11.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 47.08,
    y1: 25.82,
    x2: 42.82,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.43,
    y1: 417.37,
    x2: 54.43,
    y2: 436.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.39,313.56c9.38,.44,18.36,1.14,26.89,2.02,9.4,.98,18.28,2.18,26.57,3.5,.17,.03,10.74,2.51,10.91,2.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M38.44,303.67v2c-5.52-.46-11.2-.84-17.05-1.11-6.49-.32-13.18-.5-20.04-.54v-2c11.2,.06,21.9,.51,32.09,1.26,1.68,.12,3.35,.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M38.43,345.67v73c-1.41-.12-2.84-.23-4.27-.34-.24,0-.48-.03-.73-.05v-73c1.68,.12,3.35,.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M33.43,416.28v2c-10.18-.74-20.89-1.2-32.09-1.26v-2c9.7,.05,19.03,.4,27.97,.98,1.38,.09,2.76,.18,4.12,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M38.44,345.67v2c-1.65-.14-3.32-.27-5-.39-.01,0-.02-.01-.03,0-1.35-.1-2.72-.2-4.09-.28-1.38-.09-2.78-.18-4.18-.25-1.48-.09-2.96-.16-4.46-.23-1.34-.06-2.7-.12-4.05-.17-4.32-.16-8.72-.27-13.19-.32-.49-.01-.98-.01-1.48-.01h-.61v-2c6.87,.04,13.55,.22,20.04,.53,4.1,.19,8.11,.44,12.05,.73,1.68,.12,3.35,.25,5,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M33.43,112.28v2c-10.18-.74-20.89-1.2-32.09-1.26v-2c11.2,.06,21.91,.51,32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.34,110.01c17.09,.11,48.29,2.47,63.29,6.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.34,138.01c11.2,.07,21.91,.53,32.09,1.27,1.68,.12,3.35,.25,5,.39,2.43,.2,4.83,.41,7.2,.65,2.33,.23,22.73,1.91,25,2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.35,346.01c.2,0,.41,0,.61,.01,.5,0,.99,0,1.48,0,4.48,.04,8.88,.15,13.19,.32,1.36,.05,2.71,.11,4.05,.17,1.5,.07,2.98,.14,4.46,.23,1.4,.07,2.8,.16,4.18,.25,1.37,.08,2.74,.18,4.09,.28,.01,0,.02,0,.03,0,1.68,.12,3.35,.25,5,.39,3.3,.27,6.54,.57,9.72,.9,1.35,.14,2.68,.28,4.01,.43,7.88,.88,25.52,4.51,32.59,5.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M33.43,112.28v191c-10.18-.75-20.89-1.2-32.09-1.26V111.02c11.2,.06,21.91,.51,32.09,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M33.43,44.5v55c-11-1-19.93-1.99-32-2h-.09V44.5H33.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M38.43,112.67v192.83l-5-2V112.28c1.14,.08,2.28,.17,3.4,.26,.54,.04,1.07,.09,1.6,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M33.44,345.28v73c-10.19-.74-20.89-1.2-32.09-1.26v-73c6.87,.04,13.55,.22,20.04,.53,4.1,.19,8.11,.44,12.05,.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.43 445.5 1.34 445.5 1.34 422.5 33.43 422.5 38.13 436 41.43 445.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "39.43 445.18 1.34 445.18 1.34 423.5 31.65 423.5 32.01 424.5 33.09 427.5 33.44 428.5 34.16 430.5 34.52 431.5 35.6 434.5 35.96 435.5 36.32 436.5 36.67 437.5 37.03 438.5 37.39 439.5 38.47 442.5 38.83 443.5 39.43 445.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.34,
    y: 32.5,
    width: 36.09,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1.34,
    y: 445.5,
    width: 40.09,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M145.44,329.34v15h-4.5c-4.01,0-7.29-3.15-7.48-7.11-.02-.13-.02-.26-.02-.39,0-2.07,.84-3.94,2.2-5.3,1.36-1.36,3.23-2.2,5.3-2.2h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M140.94,329.34h4.5v1.72h-5.36c-3.51,0-6.38,2.72-6.62,6.17-.02-.13-.02-.26-.02-.39,0-2.07,.84-3.94,2.2-5.3,1.36-1.36,3.23-2.2,5.3-2.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 145.44,
    y1: 318.34,
    x2: 85.26,
    y2: 318.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 145.44,
    y1: 358.84,
    x2: 85.26,
    y2: 358.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "35.44 99.84 33.44 99.84 33.44 44.84 35.44 45.84 35.44 99.84"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_75",
    x1: 68.78,
    y1: 159.49,
    x2: 235.9,
    y2: 394.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f2f5f6",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e6ebed",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abb9c0",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7f959f",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#657f8b",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c7784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 178.39,
    y1: 345.27,
    x2: 237.17,
    y2: 383.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f2f5f6",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e6ebed",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abb9c0",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7f959f",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#657f8b",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c7784"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("use", {
    width: 145.44,
    height: 474.6,
    transform: "translate(142.62)",
    xlinkHref: "#spaceship_3"
  }), /*#__PURE__*/React.createElement("use", {
    width: 145.44,
    height: 474.6,
    transform: "translate(145.44) rotate(-180) scale(1 -1)",
    xlinkHref: "#spaceship_3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M288.06,329.33v15h-.1v22.36c0,.68-.23,1.33-.66,1.86l-8.61,10.56c-.46,.56-1.15,.89-1.88,.89h-9.47c-.76,0-1.38-.62-1.38-1.38v-12.3h-41.18l-1.57,6.53-.22,.94-4.72,19.53-.22,.93-12.39,24.53v18.51h.01v10.51s-.01-.01-.01-.01v3.2c1.88,.98,2.96,2.11,2.96,3.32v11.15c0,1.38-1.41,2.66-3.81,3.72l-.05,.33h0c0,1.23-3.12,2.24-6.97,2.24-1,0-1.94-.07-2.8-.19-.38,.04-.77,.09-1.17,.13l-.12,.86c0,1.13-2.87,2.05-6.41,2.05s-6.4-.92-6.4-2.05l-.12-.8c-.51-.04-1.01-.1-1.5-.15-.77,.09-1.6,.14-2.48,.14-3.85,0-6.97-.99-6.97-2.23v-.04c-2.83-1.11-4.51-2.5-4.51-4.01v-10.46h-5.35l-7.75-5.82-8.18-.18-8.19,.18-7.75,5.82h-5.34v10.46c0-.08,0-.16-.02-.25,0,.09,.01,.17,.01,.25,0,1.51-1.68,2.9-4.5,4.01v.04c-.01,1.24-3.13,2.23-6.98,2.23-.87,0-1.71-.05-2.48-.14-.49,.05-.99,.11-1.5,.15l-.11,.8c0,1.13-2.87,2.05-6.41,2.05s-6.4-.92-6.4-2.05l-.13-.86c-.39-.04-.78-.09-1.17-.13-.85,.12-1.8,.19-2.8,.19-3.84,0-6.97-1.01-6.97-2.23h0s-.05-.34-.05-.34c-2.4-1.06-3.8-2.34-3.8-3.72v-11.15c0-1.21,1.08-2.34,2.96-3.32v-3.2s-.01,.01-.01,.01v-10.51h.01v-18.51l-12.39-24.53-.22-.93-4.72-19.53-.22-.94-1.58-6.53H22.09v12.3c0,.76-.62,1.38-1.38,1.38H11.24c-.73,0-1.41-.33-1.87-.89l-8.62-10.56c-.42-.53-.66-1.18-.66-1.86v-22.36h-.09v-15H.09v-11.33l7.18-8.07c.52-.59,1.28-.93,2.07-.92l50.14,.1v-41.11h.15l.47-37.67,.42-1.53,6.09-34.7,.41-1.53,7.64-50.98,.22-.82h-.1l6-27.65L97.52,26.45l.02-.13,.03-.32h-.16l.13-.13,.05-.06v-.04h.03l.42-.45L118.86,3h.07l5.03-3h40.13l5.03,3h.07l10.04,10.77,10.78,11.55,.42,.45h.03v.04l.05,.06,.13,.13h-.16l.04,.32,.02,.13,10.42,53.98,6.31,32.69,6,27.65h-.1l.22,.82,6.64,44.28h0s1,6.7,1,6.7l.42,1.53,6.09,34.7,.41,1.53,.47,37.67h.15v41.11l50.15-.1c.79-.01,1.54,.33,2.07,.92l7.17,8.07v11.33h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.06,329.33v15h-.1v22.36c0,.68-.23,1.33-.66,1.86l-8.61,10.56c-.46,.56-1.15,.89-1.88,.89h-9.47c-.76,0-1.38-.62-1.38-1.38v-12.3h-41.18l-1.57,6.53-.22,.94-4.72,19.53-.22,.93-12.39,24.53v18.51h.01v10.51s-.01-.01-.01-.01v3.2c1.88,.98,2.96,2.11,2.96,3.32v11.15c0,1.38-1.41,2.66-3.81,3.72l-.05,.33h0c0,1.23-3.12,2.24-6.97,2.24-1,0-1.94-.07-2.8-.19-.38,.04-.77,.09-1.17,.13l-.12,.86c0,1.13-2.87,2.05-6.41,2.05s-6.4-.92-6.4-2.05l-.12-.8c-.51-.04-1.01-.1-1.5-.15-.77,.09-1.6,.14-2.48,.14-3.85,0-6.97-.99-6.97-2.23v-.04c-2.83-1.11-4.51-2.5-4.51-4.01v-10.46h-5.35l-7.75-5.82-8.18-.18-8.19,.18-7.75,5.82h-5.34v10.46c0-.08,0-.16-.02-.25,0,.09,.01,.17,.01,.25,0,1.51-1.68,2.9-4.5,4.01v.04c-.01,1.24-3.13,2.23-6.98,2.23-.87,0-1.71-.05-2.48-.14-.49,.05-.99,.11-1.5,.15l-.11,.8c0,1.13-2.87,2.05-6.41,2.05s-6.4-.92-6.4-2.05l-.13-.86c-.39-.04-.78-.09-1.17-.13-.85,.12-1.8,.19-2.8,.19-3.84,0-6.97-1.01-6.97-2.23h0s-.05-.34-.05-.34c-2.4-1.06-3.8-2.34-3.8-3.72v-11.15c0-1.21,1.08-2.34,2.96-3.32v-.94c48.92-36.53,93.47-101.36,119.29-181.65,8.99-27.98,15.05-55.75,18.34-82.53l1,6.7,.42,1.53,6.09,34.7,.41,1.53,.47,37.67h.15v41.11l50.15-.1c.79-.01,1.54,.33,2.07,.92l7.17,8.07v11.33h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M200.96,80.43c-11.17,35.74-27.35,72.85-48.48,109.45-33.66,58.3-74.73,106.39-116.77,140.21H0v-.76H.09v-11.33l7.18-8.07c.52-.59,1.28-.93,2.07-.92l50.14,.1v-41.11h.15l.47-37.67,.42-1.53,6.09-34.7,.41-1.53,7.64-50.98,.22-.82h-.1l6-27.65L97.52,26.45l.02-.13,.03-.32h-.16l.13-.13,.05-.06v-.04h.03l.42-.45L118.86,3h.07l5.03-3h40.13l5.03,3h.07l10.04,10.77,10.78,11.55,.42,.45h.03v.04l.05,.06,.13,.13h-.16l.04,.32,.02,.13,10.42,53.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M143.53,27.28v4.22h-37.6l3.55-3.82c8.58,1.38,18.96,1.53,30,.17,1.37-.17,2.72-.36,4.05-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M181.33,31.5h-37.6v-4.25c10.17-1.6,19.32-4.31,26.57-7.64l5.3,5.71,.62,.68,5.11,5.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M125.11,12.5h18.42v5.5c-8.18,0-15.86-1-22.51-2.76l1.64-1.76c.58-.61,1.49-.98,2.45-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M166.2,15.2c-6.63,1.77-14.3,2.78-22.47,2.8v-5.5h18.42c.96,0,1.87,.37,2.45,.98l1.6,1.72Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceshipPlayer);
export default __webpack_public_path__ + "static/media/spaceshipPlayer.4e910e5b56d7b7ec96b4f14c80b5be19.svg";
export { ForwardRef as ReactComponent };